module.exports = __webpack_public_path__ + "static/img/3-4.5c708e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3-4.png
// module id = MQ7W
// module chunks = 1